import React from "react";
import { Grid, Typography } from "@material-ui/core";
import useText from "constants/text";

export default function Success() {
  const {text} = useText();
  return (
    <Grid
      container
      spacing={2}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Grid xs={12} item style={{ width: "60%" }}>
        <Typography variant="h2" align="center">
        {text.all.thank_client}
        </Typography>
      </Grid>
      <Grid xs={12} item>
       <Typography component="p" align="center">
       {text.all.desc_success}
      </Typography> 
      </Grid>
    </Grid>
   
  );
}


